import { useEffect, useRef } from "react";

/* Mirrors a wizard step into browser history so Back/Forward (and swipe-back) move between steps. */
export function useHistoryStep(key, step, setStep) {
  const stepRef = useRef(step);
  const skipPush = useRef(false);
  stepRef.current = step;

  useEffect(() => {
    const cur = window.history.state || {};
    if (cur[key] === undefined) window.history.replaceState({ ...cur, [key]: stepRef.current }, "");
    const onPop = (e) => {
      const s = (e.state && e.state[key]) ?? 0;
      if (s === stepRef.current) return;
      skipPush.current = true;
      setStep(s);
    };
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, [key, setStep]);

  useEffect(() => {
    if (skipPush.current) { skipPush.current = false; return; }
    const cur = window.history.state || {};
    if ((cur[key] ?? 0) === step) return;
    window.history.pushState({ ...cur, [key]: step }, "");
  }, [key, step]);
}
